<div class="sim">
  <mat-list>
    <mat-divider></mat-divider>
    <mat-list-item (click)="startSim(race)">
      <img matListItemAvatar src="./assets/images/sm-logga-2024-tr.png" />
      <div matListItemTitle>Total tasks {{ race.raceName }}</div>
      <div matListItemLine>Click to start simulation...</div>
      <div matListItemLine>
        Number of workers {{ workersCount() }} Tasks received
        {{ tasksReceivedSignal() }}
      </div>
    </mat-list-item>
    @if (simulationProgress()) {
    <mat-list-item>
      <img matListItemAvatar src="./assets/images/matrix.gif" />
      <div matListItemTitle>
        Progress {{ simulationProgress().remainingTasks }} /
        {{ simulationProgress().totalTasks }}
      </div>
      <div matListItemLine>
        Active tasks: {{ simulationProgress().activeTasks }}
      </div>
      <div matListItemLine>
        <mat-progress-bar
          mode="determinate"
          [value]="simulationProgress().completionPercentage"
        ></mat-progress-bar>
      </div>
    </mat-list-item>
    }
    <mat-divider></mat-divider>
  </mat-list>

  <button (click)="reserveTask()" mat-flat-button class="start">
    Reserve task
  </button>
  <button (click)="stopSignalR()" mat-flat-button>
    Stop signalR connection
  </button>
</div>
